export const RECEIVE_ItemCategories_REQUEST = 'RECEIVE_ItemCategories_REQUEST';
export const SET_ItemCategories_FETCHING = 'SET_ItemCategories_FETCHING';
export const SET_ItemCategories_LOADING = 'SET_ItemCategories_LOADING';
export const TOGGLE_ItemCategories_BOOLEAN = 'TOGGLE_ItemCategories_BOOLEAN';
